export const enterKey = 13;
export const arrowLeftKey = 37;
export const arrowRightKey = 39;

